import type { Row } from "@rocicorp/zero";
import { blockRowNavProps } from "../lib/eventHelpers";
import { userDisplayName } from "../lib/userDisplayName";
import { Avatar } from "./Avatar";
import { FacePile } from "./FacePile";

type Member = {
  user?: Row["user"] | null;
};

export function GroupMemberFacePile({
  members,
  totalCount,
  size = 20,
  onClickMember,
  collapseToFit = false,
}: {
  members: readonly Member[];
  totalCount?: number;
  size?: number;
  onClickMember?: (userId: string) => void;
  collapseToFit?: boolean;
}) {
  const seen = new Set<string>();
  const items = members.flatMap((m) => {
    if (!m.user || m.user.deactivated || seen.has(m.user.id)) return [];
    seen.add(m.user.id);
    const userId = m.user.id;
    return [
      {
        id: userId,
        node: onClickMember ? (
          <span
            style={{ cursor: "pointer", display: "flex" }}
            {...blockRowNavProps(() => onClickMember(userId))}
          >
            <Avatar user={m.user} size={size} bare />
          </span>
        ) : (
          <Avatar user={m.user} size={size} bare />
        ),
        label: userDisplayName(m.user),
        bare: true,
      },
    ];
  });
  if (items.length === 0) return null;
  return (
    <FacePile
      itemSize={size}
      outlineWidth={2}
      maxItems={5}
      items={items}
      totalCount={totalCount}
      cutout
      collapseToFit={collapseToFit}
    />
  );
}
